import React from 'react';
import { LinkProps as RouterLinkProps } from 'react-router-dom';

import { getLinkColor, getLinkSize, getLinkFontFamily } from './helpers';
import StyledRouterLink from './StyledRouterLink';
import { colors, typography } from '@99designs/ui/settings';

export interface BaseRouterLinkProps extends RouterLinkProps {
    children?: React.ReactNode;
    size?: typography.FontFamilyLinksSize;
    color?: colors.Color;
    fontFamily?: typography.FontFamily;
    noUnderline?: boolean;
    forwardedRef?: React.RefAttributes<HTMLAnchorElement>['ref'];
}

function BaseRouterLink({
    children,
    color = 'puntRoad',
    size = 'root',
    fontFamily = 'text',
    noUnderline = false,
    forwardedRef,
    ...props
}: BaseRouterLinkProps) {
    return (
        <StyledRouterLink
            {...props}
            forwardedRef={forwardedRef}
            linkColor={getLinkColor(color)}
            size={getLinkSize(size)}
            linkFontFamily={getLinkFontFamily(fontFamily)}
            noUnderline={noUnderline}
        >
            {children}
        </StyledRouterLink>
    );
}
export default BaseRouterLink;
